import { render, staticRenderFns } from "./sHead.vue?vue&type=template&id=3b2e4eb7&scoped=true&"
import script from "./sHead.vue?vue&type=script&lang=js&"
export * from "./sHead.vue?vue&type=script&lang=js&"
import style0 from "./sHead.vue?vue&type=style&index=0&id=3b2e4eb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e4eb7",
  null
  
)

export default component.exports